import { render, staticRenderFns } from "./KPICommentsCard.vue?vue&type=template&id=79d38aec&scoped=true"
import script from "./KPICommentsCard.vue?vue&type=script&lang=js"
export * from "./KPICommentsCard.vue?vue&type=script&lang=js"
import style0 from "./KPICommentsCard.vue?vue&type=style&index=0&id=79d38aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d38aec",
  null
  
)

export default component.exports